import '@skyscanner-internal/backpack-web/bpk-stylesheets';
import 'react-app-polyfill/ie11'; // For IE 11 support

import { createElement } from 'react';

import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router';

import App from './App';

const router = createBrowserRouter([
  {
    path: '*',
    element: createElement(App),
  },
]);

const root = createRoot(document.getElementById('root'));
root.render(createElement(RouterProvider, { router }));
